import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLoginedUser } from '../../redux/slices/loginedUserSlice';

export const AdminRoute = ({ component: Component, ...rest }) => {
  const { user, isAdmin } = useSelector(selectLoginedUser);
  const isLoggedIn = !!user;
  return (
    <Route
      {...rest}
      render={(props) => ((isLoggedIn && isAdmin)
        ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        ))}
    />
  );
};
